export enum PROVIDER_DEFINITION_ID {
  EMAIL_VALUE = '53983b39-8c7d-4cac-aa0e-4219d555d91a',
  MOBILE_VALUE = 'c2ed228c-febb-4be8-9345-15ef9eac3cc1'
}
